import { render, staticRenderFns } from "./UsuarioAfiliado.vue?vue&type=template&id=fde0ca54"
import script from "./UsuarioAfiliado.vue?vue&type=script&lang=js"
export * from "./UsuarioAfiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports